<script lang="ts" setup>
import { inject, ref, onBeforeMount, watch, getCurrentInstance } from 'vue';
import { randomId } from '../../../../src/lib/ChoiceUtils';

const addTab = inject('addTab', defaultAddTab);
const activeTabHash = inject('activeTabHash', ref(randomId()));
const setActiveTab = inject('setActiveTab', defaultSetActiveTab);
const setTabValue = inject('setTabValue', defaultTabValue);

function defaultAddTab(title: string, hash: string, value: string | number, tab: any) { }
function defaultTabValue(hash: string, value: string | number) { }
function defaultSetActiveTab(hash: string) { }

const props = defineProps<
    {
        title: string,
        value: string | number
    }
>();

const hash = ref('');
const isActive = ref(false);

const emit = defineEmits<{
    "active": []
}>();

onBeforeMount(() => {
    if (props.value == undefined) {
        alert(`Value property was not provided on tab item: ${props.title}`);
    }
    hash.value = randomId();

    addTab(
        props.title,
        hash.value,
        props.value,
        getCurrentInstance()
    );
});

watch(activeTabHash, () => {
    isActive.value = activeTabHash.value === hash.value;
    if (isActive.value) {
        emit('active');
        setActiveTab(hash.value);
    }   
});

watch(() => props.value, (newValue, _oldValue) => {
    setTabValue(hash.value, newValue);
});
</script>

<template>
    <div class="p-8" v-show="isActive">
        <slot />
    </div>
</template>
